import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PlatformContext = createContext();

export const usePlatform = () => {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
};

export const PlatformProvider = ({ children }) => {
  const [currentMode, setCurrentMode] = useState('social'); // 'social' or 'business'
  const [businessNotifications, setBusinessNotifications] = useState(17); // Total notifications for business hub
  const navigate = useNavigate();

  const toggleMode = (mode) => {
    setCurrentMode(mode);
    // Save to localStorage to persist across sessions
    localStorage.setItem('platform_mode', mode);
    
    // Navigate to the appropriate route
    if (mode === 'business') {
      navigate('/business');
    } else {
      navigate('/');
    }
  };

  // Initialize from localStorage on mount
  React.useEffect(() => {
    const savedMode = localStorage.getItem('platform_mode');
    if (savedMode && (savedMode === 'social' || savedMode === 'business')) {
      setCurrentMode(savedMode);
    }
  }, []);

  const value = {
    currentMode,
    toggleMode,
    businessNotifications,
    setBusinessNotifications
  };

  return (
    <PlatformContext.Provider value={value}>
      {children}
    </PlatformContext.Provider>
  );
};